import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { IFilterProperty } from '../../../../../shared/interfaces/filters/filter-property.interface';
import { FilterRule } from '../../../../../shared/interfaces/filters/filter-rule.type';
import { FilterOptionComponent } from '../filter-option/filter-option.component';

@Component({
  standalone: false,
  selector: 'suvo-bi-dropdown-filter-option',
  templateUrl: './dropdown-filter-option.component.html',
  styleUrls: ['./dropdown-filter-option.component.scss'],
})
export class DropdownFilterOptionComponent extends FilterOptionComponent implements OnInit {
  constructor() {
    super();

    this.formGroup = new FormGroup({
      dropdown: new FormControl(),
    });
    this.hookForm(this.formGroup);
  }

  getFilterRules(option): FilterRule[] {
    if (option?.dropdown?.value) {
      return [
        {
          key: this.option.filterPropertyKeys[0],
          eq: option?.dropdown?.value,
        },
      ];
    } else if (option?.dropdown?.extraFilterRules) {
      return option?.dropdown?.extraFilterRules;
    }
    return [];
  }

  patchRules(rules: FilterRule[]) {
    if (this.option.filterMethodConfig.usingExtraFilterRules) {
      let rulesString = JSON.stringify(rules);

      for (let dropdownOption of this.option.filterMethodConfig.options) {
        let optionRulesString = JSON.stringify(dropdownOption.extraFilterRules);

        if (optionRulesString == rulesString) {
          this.formGroup.patchValue({ radio: dropdownOption }, { emitEvent: false });
        }
      }
    } else {
      const property = rules[0] as IFilterProperty;
      const patchValue = property?.eq;

      for (let dropdownOption of this.option.filterMethodConfig.options) {
        if (patchValue == dropdownOption.value) {
          this.formGroup.patchValue({ dropdown: dropdownOption }, { emitEvent: false });
        }
      }
    }
  }
}
